import { render, staticRenderFns } from "./ModalFP.vue?vue&type=template&id=7c438620&"
import script from "./ModalFP.vue?vue&type=script&lang=js&"
export * from "./ModalFP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports